import { Component } from 'react';

export default class ErrorBoundary extends Component {
    state = { hasError: false, error: null }

    static getDerivedStateFromError(error) {
        return { hasError: true, error }
    }

    render() {
        if (this.state.hasError) return <ErrorDisplay error={this.state.error.message} />
        return this.props.children
    }
}

function ErrorDisplay({ error }) {
    return (
        <div
            className="error-boundary"
            style={{
                width: `80vw`,
                height: `80vh`,
                margin: `0 auto`,
                textAlign: "center",
            }}
        >
            <h1 style={{ fontSize: "2rem" }}>An error occured</h1>
            <p>Please make sure you're connected to the internet and reload the page</p>
            <p
                style={{
                    color: "red",
                    maxWidth: 600,
                    margin: '0 auto',
                    textAlign: 'left'
                }}>{JSON.stringify(error, null, 2)}
            </p>
        </div>
    )
}
